export const KNOWLEDGE_BASE_URL = {
  CUSTOM_STYLING: 'https://knowledge-base.yieldbird.com/special-ad-slots/multianchor',
} as const
